import React from "react";
import { XIcon } from "@heroicons/react/solid";
import axios from "axios";
import useState from "react-usestateref";
import backendService from "../services.js/backendService";
import { PuffLoader } from "react-spinners";
import ReactPlayer from "react-player";
import DocViewer, { DocViewerRenderers } from "react-doc-viewer";
import { Logger } from "logging-library";
import FileViewer from "react-file-viewer";
import { CustomErrorComponent } from "custom-error";


function FileViewerModal({ openFileViewerModal, File }) {
  

  return (
    <>
      <div className="justify-center  m-4 items-center  flex  fixed inset-0 z-50 outline-none focus:outline-none select-none">
        <div className="w-full h-auto max-h-[90vh] bg-palette_color2 shadow-black my-6 mx-auto max-w-6xl rounded-md">
          {/*content*/}
          <div className="border-0 rounded-lg h-full w-auto  relative flex flex-col   outline-none focus:outline-none"> {/* h-full here is fine, it refers to max-h-[90vh] of parent */}
            {/*header*/}
            <div className="flex items-start justify-between w-auto h-[7%] p-5 sticky top-0  rounded-t bg-background">
              <h3 className="text-3xl font-robo text-primary ">File Preview</h3>
              <div className="h-7 w-7 flex items-center justify-center cursor-pointer hover:bg-palette_color1 hover:text-palette_color2 text-palette_color1 hover:rounded-full">
                <XIcon
                  className="h-5 w-5 "
                  aria-hidden="true"
                  onClick={() => openFileViewerModal(false)}
                />
              </div>
            </div>
            {/*body*/}

            <div className="flex-1 min-h-0"> {/* Changed from h-[93%] */}
              <div className="h-full  overflow-x-hidden  overflow-y-auto chat__container p-4">
                <FileViewer
                  fileType={File?.fileExtension}
                  filePath={File?.filePath}
                  noth
                  errorComponent={CustomErrorComponent}
                />
              </div>
            </div>
            {/*footer*/}
          </div>
        </div>
      </div>
      <div className="opacity-50  fixed inset-0 z-20 bg-black"></div>
    </>
  );
}

export default FileViewerModal;
